import { render } from "./Results.vue?vue&type=template&id=7180ed3a"
import script from "./Results.vue?vue&type=script&lang=ts"
export * from "./Results.vue?vue&type=script&lang=ts"

import "./Results.vue?vue&type=style&index=0&id=7180ed3a&lang=css"
script.render = render

export default script